import axios from "../common/Axios";

function getUser() {
  return axios.get("/user").then(user => {
    user.hasRole = role => user.roles.includes(role);
    return user;
  });
}

function login(username, password) {

  //Envio de credenciales por body
  return axios
      .post(`/user/login`,{username,password})
      .then(user => {
          user.hasRole = role => {
              return user.roles.includes(role);
          };
          return user;
      });

  //Envio de credenciales por query params
  /*return axios
    .post(`/user/login?userName=${username}&password=${password}`)
    .then(user => {
      user.hasRole = role => {
        return user.roles.includes(role);
      };
      return user;
    });*/
}

function logout() {
  return axios.post(`/user/logout`);
}

function getFavorites() {
  return axios.get("/favorites").then(favorites => {
    if (Array.isArray(favorites) && favorites.length) {
      favorites.forEach(elem => {
        switch (elem.application) {
          case "COST":
            elem.color = "#8BC34A";
            break;
          case "SPAC":
            elem.color = "#FFC107";
            break;
          case "MAC":
            elem.color = "#FFC107";
            break;
          //TODO agregar otros colores segun aplicación tgs
          default:
            elem.color = "#5C5C5C";
            break;
        }
      });
    }
    return favorites;
  });
}

function addFavorite(route) {
  return axios.post(`/favorites?favoriteUri=${route}`);
}

function removeFavorite(favoriteId) {
  return axios.delete(`/favorites?favoriteId=${favoriteId}`);
}

function changePassword(oldPassword, newPassword, retryNewPassword) {
  return axios.post(
      "user/changepassword", {oldPassword, newPassword, retryNewPassword}
  );
}

function validatePermisos() {
  return axios.get("user/validatePermisos");
}

function loginToken(token) {

  const headers = {
    Authorization: 'Bearer ${token}',
    'Content-Type': 'application/json',
    };
    

  //Envio de credenciales por body
  return axios
      .post(`/auth/loginToken`,{token})
      .then(user => {
        user.hasRole = role => {
            return user.roles.includes(role);
        };
        return user;
    });

}

export default {
  getUser,
  login,
  logout,
  getFavorites,
  addFavorite,
  removeFavorite,
  changePassword,
  validatePermisos,
  loginToken
};
